import React from 'react';
import classes from './CheckoutModal.module.scss';
import closeIcon from '../../../assets/images/closeIcon.png';
import cx from 'classnames';
import SeatingMap from '../../FormSelectYourSeat/SeatingMap';

const CheckoutModal = (props) => {
  return (
    <div
      className={cx(
        classes.modal,
        props.checkoutModalToggle === true ? classes.modalActive : ''
      )}
    >
      <div className={classes.modaBody}>
        {/* <div className={classes.modalTitle}>Term and conditions</div> */}
        <SeatingMap
          seatsInfo={[{ name: props.seatInfoSelectedName }]}
          seatInfoSelectedKey={0}
        />
        <img
          className={classes.closeIcon}
          src={closeIcon}
          alt="Close Icon"
          onClick={() => props.onClickCheckoutModalToggle()}
        />
      </div>
    </div>
  );
};

export default CheckoutModal;
